export default "__VITE_ASSET__DdXYr3jj__"